(function paycheckRRHHDetailControllerDefinition() {
    'use strict';

    angular.module('PaycheckRRHH')
        .controller('PaycheckRRHHDetailController', [
            '$filter', '$state', '$scope', '$stateParams', '$translate', 'alerts', 'errorsExtend', 'processService', 'fileWorkflowService', 'authExtend', 'configViewService', '$q', 'fileDownloader', '$window', 'adminOrganizationalUnitService',
            function paycheckRRHHDetailController($filter, $state, $scope, $stateParams, $translate, alerts, errors, processService, fileWorkflowService, auth, configViewService, $q, fileDownloader, $window, adminOrganizationalUnitService) {

                $scope.preview = {
                    closed: true,
                    loading: false,
                    content: null,
                    index: null,
                    item: null,
                    invalid: false
                };

                $scope.setPaycheck = function (paycheck) {
                    $scope.paycheck = paycheck;
                    return adminOrganizationalUnitService.getConfigs(paycheck.organizationalUnitId);
                };

                $scope.loadConfig = function (configs) {
                    var paycheckType = $filter('filter')($scope.paycheck.metadataValues, { systemName: '_trec' }, true);
                    var config = $filter('filter')(configs, function (item) {
                        return paycheckType.length > 0 && item.configName === '#OuConfigRA' + paycheckType[0].value;
                    }, true);

                    if (config.length === 0) {
                        config = $filter('filter')(configs, { configName: '#OuConfigSectionPaychecks' }, true);
                    }

                    if (config.length > 0) {
                        var metadata = $filter('filter')(config[0].metatadataValues, { name: '#PaycheckMotiveDisagreement' }, true);
                        if (metadata.length > 0) {
                            $scope.showMotiveDisagreement = metadata[0].value === 'true';
                        }
                    }

                    return configViewService.getById('CPPPaycheckRRHH');
                };

                $scope.setConfig = function (configView) {
                    $scope.configView = configView;
                    var metadatas = [];
                    var processType = $filter('filter')($scope.configView.processTypes, { processTypeId: $scope.paycheck.paycheckTypeId }, true);
                    if (processType.length === 0) {
                        $scope.paycheck.metadataValues = metadatas;
                        return;
                    }

                    processType[0].metadatas.forEach(function (paycheckMetadata) {
                        if (paycheckMetadata.systemName === '_motivodisc' && !$scope.showMotiveDisagreement) {
                            return;
                        }

                        if (paycheckMetadata.detailCriteria) {
                            var metadataFound = $filter('filter')($scope.paycheck.metadataValues, { systemName: paycheckMetadata.systemName }, true);

                            var value = null;
                            var desc = null;

                            if (metadataFound.length > 0) {
                                value = metadataFound[0].value;
                                desc = metadataFound[0].description;
                            }

                            metadatas.push({
                                metadataId: paycheckMetadata.metadataId,
                                type: paycheckMetadata.metadataType != null ? paycheckMetadata.metadataType.toLowerCase() : undefined,
                                name: paycheckMetadata.detailCriteria.name,
                                isVisible: true,
                                maskOptions: paycheckMetadata.maskOptions,
                                systemName: paycheckMetadata.systemName,
                                order: paycheckMetadata.detailCriteria.order,
                                value: value,
                                description: desc,
                                mask: paycheckMetadata.detailCriteria.mask
                            });
                        }
                    });

                    metadatas.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    $scope.paycheck.metadataValues = metadatas;
                    $scope.loadActions(processType[0], $scope.paycheck);
                    var item = {};

                    $scope.paycheck.files.forEach(function (file) {
                        item.creationDate = file.creationDate;
                        item.name = file.name;
                        item.size = file.size;
                        item.id = file.id;
                        item.stream = null;
                    });

                    $scope.previewFile(item, 0);
                };

                $scope.showError = function (error) {
                    errors.showError(error);
                    $scope.cancel();
                };

                $scope.previewFile = function (item, index) {
                    $scope.preview.content = null;
                    $scope.preview.loading = true;
                    $scope.preview.closed = false;
                    $scope.preview.invalid = false;

                    fileWorkflowService.preview(item, true).then(function (result) {
                        $scope.preview.content = result;

                        $scope.preview.item = item;
                        $scope.preview.index = index;
                        $scope.preview.loading = false;
                    }, function (error) {
                        if (error.data && error.data.modelState && error.data.modelState.no_converter) {
                            $scope.preview.loading = false;
                            $scope.preview.invalid = true;
                            $scope.preview.item = item;
                            $scope.preview.index = index;
                        }
                        else {
                            errors.showError(error);
                            //$scope.hidePreview();
                        }
                    });
                };

                $scope.cancel = function () {
                    $state.go('paycheck-rrhh-find');
                };

                $scope.delete = function () {
                    return $translate(['Warning', 'DeletePaycheckConfirmText', 'Yes', 'No']).then(function (translated) {
                        return alerts.confirm(translated.Warning, translated.DeletePaycheckConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                            if (result) {
                                return processService.delete($stateParams.id).then(function () {
                                    $window.history.back();
                                }, function (error) {
                                    errors.showError(error);
                                });;
                            }
                        });
                    });
                };

                $scope.edit = function () {
                    $state.go('paycheck-rrhh-edit', { id: $scope.paycheck.id });
                };

                $scope.retry = function () {
                    return processService.execute($stateParams.id).then(function (result) {
                        errors.showSuccess('ProcessRetryingSuccess');
                        $scope.load();
                    }, function (error) {
                        errors.showError(error);
                        $scope.load();
                    });
                };

                $scope.history = function (proc) {
                    $state.go('process-history', { id: proc.id });
                };

                $scope.loadActions = function (processType, process) {
                    var result = $filter('filter')(processType.groupStates, function (item) {
                        return item.ids.indexOf(process.stateId) > -1;
                    }, true);

                    if (result.length > 0) {
                        $scope.actions = {
                            delete: result[0].delete,
                            edit: result[0].edit,
                            editName: 'PaycheckRRHH' + result[0].editName,
                            retry: result[0].retry
                        };
                    }
                };

                $scope.load = function () {
                    $scope.actions = {
                        delete: false,
                        edit: false,
                        editName: 'Edit',
                        retry: false
                    };

                    $scope.userId = auth.getUserId();
                    $scope.writePermission = auth.isInRole('PAYCHECK WRITE');
                    $scope.signPermission = auth.isInRole('PAYCHECK SIGN');
                    $scope.deletePermission = auth.isInRole('PAYCHECK DELETE');
                    $scope.processHistoryPermission = auth.isInRole('PAYCHECK READ');
                    $scope.showMotiveDisagreement = false;

                    processService.getById($stateParams.id)
                        .then($scope.setPaycheck, $scope.showError)
                        .then($scope.loadConfig, $scope.showError)
                        .then($scope.setConfig, $scope.showError);
                };

                $scope.downloadFile = function () {
                    var metadata = {
                        nrolegValue: '',
                        periValue: '',
                        trecValue: ''
                    };
                    
                    if ($scope.paycheck.files.length < 2) {
                        for (var i = 0; i < $scope.paycheck.metadataValues.length; i++) {
                            switch ($scope.paycheck.metadataValues[i].systemName) {
                                case '_nroleg': metadata.nrolegValue = $scope.paycheck.metadataValues[i].value; break;
                                case '_peri': metadata.periValue = $scope.paycheck.metadataValues[i].value; break;
                                case '_trec': metadata.trecValue = $scope.paycheck.metadataValues[i].value; break;
                            }
                        }
                        $scope.paycheck.files.forEach(function (file) {
                            return fileWorkflowService.downloadFile(file.id).then(function (result) {

                                var fileName = metadata.nrolegValue + ' - ' + metadata.periValue + ' - ' + metadata.trecValue + ' - ' + $scope.paycheck.stateAlias + ' [' + $scope.paycheck.files[0].creationDate.replace(/:/g, '.') + '].pdf';
                                var success = fileDownloader.saveAs(result, fileName);

                                if (!success) {
                                    errors.showError('Api failed');
                                }

                            }, function (error) {
                                if (error.status === 204) {
                                    errors.showWarning('The document has no files');
                                } else {
                                    errors.showError('Api failed');
                                }
                            });
                        });
                    }
                    else {
                        var files = [];

                        $scope.paycheck.files.forEach(function (file) {
                            files.push({ id: file.id, name: file.name });
                        });

                        return fileWorkflowService.downloadFilesIntoZip(files).then(function (result) {

                            var success = fileDownloader.saveAs(result.value, $translate.instant('PaycheckAllFiles') + '.zip');

                            if (!success) {
                                errors.showError('Api failed');
                            }

                        }, function (error) {
                            if (error.status === 204) {
                                errors.showWarning('The document has no files');
                            } else {
                                errors.showError('Api failed');
                            }
                        });
                    }
                };

                $scope.load();
            }
        ]);
})();
